var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt008ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ai_color_diamond",
    transform: "translate(-500 -424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 472) rotate(-45)",
    fill: "#e5fffe",
    stroke: "#09e8df",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "artificial_intelligence",
    transform: "translate(527.5 452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 40,
    height: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(6.674 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M20.291,8.033,18.625,8.7a5,5,0,0,0-1.117-.65l-.25-1.767A.333.333,0,0,0,16.925,6H14.258a.31.31,0,0,0-.317.283l-.25,1.767a4.667,4.667,0,0,0-1.117.65l-1.667-.667a.322.322,0,0,0-.4.15l-1.333,2.3a.333.333,0,0,0,.083.433l1.417,1.1a2.777,2.777,0,0,0-.083.65,4.268,4.268,0,0,0,.05.65l-1.4,1.1a.315.315,0,0,0-.083.417l1.333,2.317a.343.343,0,0,0,.417.15l1.65-.667a4.767,4.767,0,0,0,1.133.65l.233,1.767a.333.333,0,0,0,.333.283h2.667a.333.333,0,0,0,.333-.283l.25-1.767a4.667,4.667,0,0,0,1.117-.65l1.65.667a.3.3,0,0,0,.4-.15l1.333-2.317a.312.312,0,0,0-.083-.417l-1.383-1.1a4.268,4.268,0,0,0,.05-.65,3.96,3.96,0,0,0-.05-.65l1.417-1.1a.333.333,0,0,0,.083-.433l-1.333-2.3A.35.35,0,0,0,20.291,8.033Zm-4.7,7.017a2.383,2.383,0,1,1,2.383-2.383,2.383,2.383,0,0,1-2.383,2.383Z",
    transform: "translate(-0.598 -1)",
    fill: "#09e8df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M30.564,13.1A11.773,11.773,0,0,0,19.681,3.017C19.447,3,19.231,3,19,3A11.667,11.667,0,0,0,7.464,13L4.247,18.8a1.667,1.667,0,0,0,1.417,2.533H7.331v3.333A3.343,3.343,0,0,0,10.664,28h1.667v5H24V25.2a11.693,11.693,0,0,0,6.567-12.1Zm-8.417,9.283-1.483.7v6.583h-5v-5h-5V18H8.5l2.217-3.883a8.318,8.318,0,1,1,11.433,8.267Z",
    transform: "translate(-4.004 -3)",
    fill: "#09e8df"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt008ColorDiamond);
export default __webpack_public_path__ + "static/media/PT008_color_diamond.c76344769bb068e14a906c423312ffbd.svg";
export { ForwardRef as ReactComponent };